module.exports = __webpack_public_path__ + "img/contact-logo.828e370c.png";